import apiClient from './client'
import type {
  GetProfileResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
  UpdateLanguageRequest,
  UpdateLanguageResponse,
  ChangePasswordRequest,
} from '@/types/api'

export const userApi = {
  getProfile() {
    return apiClient.get<GetProfileResponse>('/users/me')
  },

  updateProfile(data: UpdateProfileRequest) {
    return apiClient.patch<UpdateProfileResponse>('/users/me', data)
  },

  updateLanguage(data: UpdateLanguageRequest) {
    return apiClient.patch<UpdateLanguageResponse>('/users/me/language', data)
  },

  changePassword(data: ChangePasswordRequest) {
    return apiClient.patch('/users/me/password', data)
  },
}
